import {PostHog} from './posthog';

type EventProperties = Record<string, unknown>;

class Analytics {
  static initialize() {
    PostHog.initialize();
  }

  static identify(id?: string) {
    PostHog.identify(id);
  }

  static addEventProperties(data: EventProperties) {
    PostHog.register(data);
  }

  static addPersonProperties(data: EventProperties) {
    PostHog.setPersonProperties(data);
  }

  static track(event: string, data?: EventProperties) {
    PostHog.track(event, data);
  }
}

export {Analytics};
